// @ts-nocheck
import { useRef, useState } from "react";
import { Camera, X } from "lucide-react";
import jsQR from "jsqr";

interface Props {
  onScan: (value: string) => void;
  onClose: () => void;
  label?: string;
}

export function QrScanner({ onScan, onClose, label = "Scan QR code" }: Props) {
  const fileRef = useRef<HTMLInputElement>(null);
  const [manual, setManual] = useState("");
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState("");

  async function handleFile(file: File) {
    setProcessing(true);
    setError("");
    try {
      const bitmap = await createImageBitmap(file);
      const canvas = document.createElement("canvas");
      canvas.width = bitmap.width;
      canvas.height = bitmap.height;
      const ctx = canvas.getContext("2d");
      if (!ctx) throw new Error("Canvas not available");
      ctx.drawImage(bitmap, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const code = jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: "dontInvert",
      });
      if (code?.data) {
        onScan(code.data);
      } else {
        setError("No QR code found in image. Try again or type the value below.");
      }
    } catch (e: any) {
      setError("Could not read image. Try again or type the value below.");
    } finally {
      setProcessing(false);
    }
  }

  function handleManual(e: React.FormEvent) {
    e.preventDefault();
    if (manual.trim()) onScan(manual.trim());
  }

  return (
    <div className="qr-scanner-overlay">
      <div className="qr-scanner-dialog">
        <div className="qr-scanner-header">
          <span>{label}</span>
          <button onClick={onClose}><X size={18} /></button>
        </div>

        <div className="qr-scanner-body">
          {/* Primary: camera/file input — on mobile triggers camera directly */}
          <button
            className="qr-camera-btn"
            disabled={processing}
            onClick={() => fileRef.current?.click()}
          >
            <Camera size={24} />
            <span>{processing ? "Reading…" : "Take photo or choose image"}</span>
          </button>
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            capture="environment"
            style={{ display: "none" }}
            onChange={e => {
              const file = e.target.files?.[0];
              if (file) handleFile(file);
              e.target.value = "";
            }}
          />

          {error && <p className="qr-scanner-error" style={{padding:"0 16px"}}>{error}</p>}

          <div className="qr-scanner-divider"><span>or type manually</span></div>

          <form className="qr-scanner-manual" onSubmit={handleManual}>
            <input
              type="text"
              placeholder="Type or paste the code value"
              value={manual}
              onChange={e => setManual(e.target.value)}
            />
            <button type="submit" disabled={!manual.trim()}>
              Use value
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
